module.exports = __webpack_public_path__ + "912635f9949bcf80bc02ef94a624e825.pdf";